<template>
  <!-- overflow-x fixes the horizontal scroll caused by container fluid in HomeContent -->
  <div style="overflow-x:hidden">
    <hello-banner />
    <nav-bar />
    <home-content />
    <site-footer />
  </div>
</template>

<script>
import HelloBanner from './header/HelloBanner.vue';
import HomeContent from './HomeContent.vue';
import SiteFooter from './SiteFooter.vue';
import NavBar from './NavBar/NavBar.vue';

export default {
  name: 'HomePage',

  components: {
    HelloBanner,
    HomeContent,
    NavBar,
    SiteFooter,
  },
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
  color: inherit;
}

.visible-link {
  /* color: #247c6c !important; */
  background-image: linear-gradient(0deg, #c2c0eb88, #c2c0eb88); 
  /* , #d6d5f0cc, #d6d5f0cc, #d6d5f0cc); */
  background-position: 100% 90%;
  background-repeat: no-repeat;
  background-size: 100% 25%;
  /* transition: background-position 0.2s ease, color 0.3s ease; */
  transition: background-size 0.2s ease-in-out, background-position 0.2s ease-in-out;
}

.visible-link:hover {
  background-image: linear-gradient(0deg, #c2c0eb88, #c2c0eb88); 
  background-size: 100% 100%;
  background-position: 0% 0%;
  transition: background-size 0.2s ease-in-out, background-position 0.3s ease-in-out;
}

.content-section {
  padding: 20px 10px;
}

.content-section__header {
  font-size: 2em;
  font-weight: 800;
  padding-top: 20px;
  padding-bottom: 4px;
  text-align: center;
  font-family: 'Avenir', Helvetica, Arial, sans-serif; /* this was it */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.content-section__body {
  padding: 4px;
  padding-bottom: 20px;
}

.content-section__body p {
  margin-bottom: 1em;
}
</style>
